var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFEEA9;}\r\n\t.st1{fill:#D32436;}\r\n\t.st2{fill:#8DD1D3;}\r\n\t.st3{fill:#330D00;}\r\n\t.st4{fill:none;stroke:#330D00;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x34_0-Id_Card"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_9-Formula"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_8-Elbow"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_7-Diploma"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_6-Laptop"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_5-Brush"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_4-Baseball"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_3-Student"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_2-Highlighter"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_1-Ruler"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_0-Caliper"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_9-Ruler_Elbow"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_8-Abacus"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_7-Id_Card"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_6-Eraser"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_5-Pencil"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_4-Ink"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_3-Graduation_Cap"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_2-_Sling_Bag"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_1-Rugby_Ball"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_0-Clock"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_9-Certificate"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_8-Idea"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_7-Bookshelf"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 46.3,
    width: 13.2,
    x: 5.5,
    y: 16.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 61.8,
    width: 15.4,
    x: 18.8,
    y: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "58.5,59.8 45.6,62.9 34.2,18.1 47.1,15    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.7,22.1H8.6c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h7.1c0.6,0,1.1-0.5,1.1-1.1      C16.8,22.6,16.3,22.1,15.7,22.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23,8.8H30c0.6,0,1.1-0.5,1.1-1.1S30.6,6.6,30,6.6H23c-0.6,0-1.1,0.5-1.1,1.1S22.3,8.8,23,8.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23,57.4H30c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1H23c-0.6,0-1.1,0.5-1.1,1.1      C21.8,56.9,22.3,57.4,23,57.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.7,55.2H8.6c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h7.1c0.6,0,1.1-0.5,1.1-1.1      C16.8,55.7,16.3,55.2,15.7,55.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.6,59.5L48.1,14.7c-0.1-0.6-0.7-0.9-1.3-0.8l-11.5,2.8V1.1c0-0.6-0.5-1.1-1.1-1.1H18.8      c-0.6,0-1.1,0.5-1.1,1.1v14.3H5.5c-0.6,0-1.1,0.5-1.1,1.1v46.3c0,0.6,0.5,1.1,1.1,1.1h13.2h15.4c0.6,0,1.1-0.5,1.1-1.1v-36      l9.2,36.3c0.1,0.5,0.6,0.8,1.1,0.8c0.1,0,0.2,0,0.3,0l12.9-3.1c0.3-0.1,0.5-0.3,0.7-0.5C59.6,60.1,59.6,59.8,59.6,59.5z       M6.6,17.7h11v44.1h-11V17.7z M33.1,61.8H19.9V16.6V2.2h13.2V61.8z M46.4,61.6L35.6,18.9l10.7-2.6L57.1,59L46.4,61.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.3,21l-6.9,1.7c-0.6,0.1-1,0.7-0.8,1.3c0.1,0.5,0.6,0.8,1.1,0.8c0.1,0,0.2,0,0.3,0l6.9-1.7      c0.6-0.1,1-0.7,0.8-1.3S45.9,20.8,45.3,21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.8,56c0.1,0.5,0.6,0.8,1.1,0.8c0.1,0,0.2,0,0.3,0l6.9-1.7c0.6-0.1,1-0.7,0.8-1.3      c-0.1-0.6-0.7-0.9-1.3-0.8l-6.9,1.7C46,54.9,45.6,55.5,45.8,56z"
  })))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_6-Formula"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_5-Bell"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_4-Magnifying_Glass"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_3-Calculator"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_2-Eyeglasses"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_1-Bus"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_0-Trophy"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "_x39_-Globe"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "_x38_-Basket_Ball"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "_x37_-Pen"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "_x36_-Board"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_-Bag"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "_x34_-Exam"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_-Book"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_-Ruler"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_-Building"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookcase);
export default __webpack_public_path__ + "static/media/bookcase.f639cc4ceebdafddc75e39b95a631bb9.svg";
export { ForwardRef as ReactComponent };